<template>
  <div class="modal-content">
    <div class="modal-body">
      <transportation-route-details :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :component="component" v-on:close="hideModal" v-on:save="save" />
    </div>
  </div>
</template>

<script>

import TransportationRouteDetails from '~/components/TransportationRouteDetails'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (category) {
      this.$emit('save', category)
    }
  },
  components: {
    TransportationRouteDetails
  }
}

</script>